/* eslint-disable */
/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
// Chakra imports
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/auth/auth.png";
import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import Card from "components/card/Card";
import { useAuth } from "contexts/AuthContext";
import AuthApi from "api/auth";
import { setAuthToken } from "api";

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const googleBg = useColorModeValue("secondaryGray.300", "whiteAlpha.200");
  const googleText = useColorModeValue("navy.700", "white");
  const googleHover = useColorModeValue(
    { bg: "gray.200" },
    { bg: "whiteAlpha.300" }
  );
  const googleActive = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.200" }
  );

  // Show password
  const [show, setShow] = React.useState(false);
  const handleClick = () => { if (!isSigningIn) { setShow(!show); } }


  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(undefined);
  const { user, setUser } = useAuth();
  const history = useHistory();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [isAutoSigningIn, setIsAutoSigningIn] = useState(false);

  useEffect(() => {
    if (user) {
      setIsAutoSigningIn(true);
      AuthApi.check().then(() => {
        history.replace('/analytics/dashboard');
      }, (error) => {
        setIsAutoSigningIn(false);
      });
    }
  }, []);


  const login = async (event: React.MouseEvent<HTMLElement>) => {
    if (event) {
      event.preventDefault();
    }
    // TODO would need to check that the token is still valid
    // if (user && user.token) {
    //   console.log(`Already logged in using ${user}`)
    //   return history.push('/analytics/dashboard');
    // }
    if (username === '') {
      return setError('Username is empty.');
    }
    if (password === '') {
      return setError('Password is empty.');
    }
    setIsSigningIn(true);

    try {
      let response = await AuthApi.Login({ username, password });
      if (response.data && response.data.success !== true) {
        setIsSigningIn(false);
        console.error(response.data)
        return setError(response.data.message);
      }

      // Logged in.
      const user = response.data.user;
      user.token = response.data.token;
      setUser(user);
      setAuthToken(user.token);
      localStorage.setItem('user', JSON.stringify(user))
      console.log(user)
      return history.push('/analytics/dashboard');
    } catch (err: any) {
      console.error(err);
      setIsSigningIn(false);
      if (err.response && err.response.data && err.response.data.message) {
        return setError(err.response.data.message);
      }
      return setError('There has been an error.');
    }
  };


  return (
    <DefaultAuth>
      <Flex
        /*maxW={{ base: "100%", md: "max-content" }}*/
        maxW="100%"
        w='100%'
        mx={{ base: "auto", lg: "0px" }}
        me='auto'
        h='100%'
        alignItems='start'
        justifyContent='center'
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "14vh" }}
        flexDirection='column'>
        <Box me='auto'>
          {/* 
          <Text
            mb='36px'
            ms='4px'
            color={textColorSecondary}
            fontWeight='400'
            fontSize='md'>
            Enter your email and password to sign in!
          </Text>
          */}
        </Box>
        <Card
          w={{ base: "100%", md: "420px" }}
          mx="auto"
          p="50px"
          /*zIndex='2'
          direction='column'
          w={{ base: "100%", md: "420px" }}
          w="100%"
          maxW='100%'
          background='transparent'
          borderRadius='15px'
          mx={{ base: "auto", lg: "unset" }}
          me='auto'
          mb={{ base: "20px", md: "auto" }}*/>
          {/* 
          <Button
            fontSize='sm'
            me='0px'
            mb='26px'
            py='15px'
            h='50px'
            borderRadius='16px'
            bg={googleBg}
            color={googleText}
            fontWeight='500'
            _hover={googleHover}
            _active={googleActive}
            _focus={googleActive}>
            <Icon as={FcGoogle} w='20px' h='20px' me='10px' />
            Sign in with Google
          </Button>
          <Flex align='center' mb='25px'>
            <HSeparator />
            <Text color='gray.400' mx='14px'>
              or
            </Text>
            <HSeparator />
          </Flex>
        */}

          <Heading color={textColor} fontSize='36px' mb='30px'>
            Sign In
            {isAutoSigningIn && <Spinner me='16px' float='right' mt='10px' />}
          </Heading>
          {error &&
            <Alert status='error' mb='16px'>
              <AlertIcon />
              {error}
            </Alert>
          }
          <FormControl isDisabled={isSigningIn}>
            <FormLabel
              display='flex'
              ms='4px'
              fontSize='sm'
              fontWeight='500'
              color={textColor}
              mb='8px'
            >
              Username<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              isRequired={true}
              variant='auth'
              fontSize='sm'
              ms={{ base: "0px", md: "0px" }}
              type='username'
              placeholder='Username'
              mb='24px'
              fontWeight='500'
              size='lg'
              defaultValue={username}
              onChange={(event) => {
                setUsername(event.target.value);
                setError(undefined);
              }}
            />
            <FormLabel
              ms='4px'
              fontSize='sm'
              fontWeight='500'
              color={textColor}
              display='flex'>
              Password<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size='md'>
              <Input
                isRequired={true}
                fontSize='sm'
                placeholder='Password'
                mb='24px'
                size='lg'
                type={show ? "text" : "password"}
                variant='auth'

                defaultValue={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setError(undefined);
                }}
              />
              <InputRightElement display='flex' alignItems='center' mt='4px'>
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: "pointer" }}
                  as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={handleClick}
                />
              </InputRightElement>
            </InputGroup>
            <Flex justifyContent='space-between' align='center' mb='24px'>
              <FormControl display='flex' alignItems='center' isDisabled={isSigningIn}>
                <Checkbox
                  id='remember-login'
                  colorScheme='brandScheme'
                  me='10px'
                />
                <FormLabel
                  htmlFor='remember-login'
                  mb='0'
                  fontWeight='normal'
                  color={textColor}
                  fontSize='sm'>
                  Keep me logged in
                </FormLabel>
              </FormControl>

              {/* 
              <NavLink to='/auth/forgot-password'>
                <Text
                  color={textColorBrand}
                  fontSize='sm'
                  w='124px'
                  fontWeight='500'>
                  Forgot password?
                </Text>
              </NavLink>
            */}
            </Flex>
            <Button
              fontSize='sm'
              variant='brand'
              fontWeight='500'
              w='100%'
              h='50'
              mb='24px'
              disabled={isSigningIn}
              onClick={login}
            >
              {isSigningIn ? (<><Spinner me='16px' />Signing In...</>) : 'Sign In'}
            </Button>
          </FormControl>

          {/* 
          <Flex
            flexDirection='column'
            justifyContent='center'
            alignItems='start'
            maxW='100%'
            mt='0px'>
            <Text color={textColorDetails} fontWeight='400' fontSize='14px'>
              Not registered yet?
              <NavLink to='/auth/sign-up'>
                <Text
                  color={textColorBrand}
                  as='span'
                  ms='5px'
                  fontWeight='500'>
                  Create an Account
                </Text>
              </NavLink>
            </Text>
          </Flex>
          */}
        </Card>
      </Flex>
    </DefaultAuth >
  );
}

export default SignIn;
